import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));

export function formatRoastDate(iso: string): string {
  const [, month, day] = iso.split('-');
  return `${day}.${month}`;
}
